import { Hero } from './Hero'
import { SmallHero } from './SmallHero'

export default Hero
export {
  SmallHero,
}
